const dashboardMenus = [
    ['환경설정', 
        [
            {name: '기본환경설정', path: '/basicConfig'}, 
            {name: '담당자설정', path: '/adminAuthConfig'}, 
            {name: '색상설정', path: '/themeConfig'}, 
            {name: '상단메뉴설정', path: '/menuConfig'}, 
            {name: '슬라이더관리', path: '/popUpConfig'}, 
            {name: '내용관리', path: '/contConfig'}, 
            {name: '팝업관리', path: '/popupConfig2'}, 

        ]
    ],
    ['회원관리', 
        [
            {name: '회원관리', path: '/memberConfig'}, 
            {name: '포인트관리', path: '/pointConfig'}, 
        ]],
    ['게시판관리', 
        [
            {name: '게시판관리', path: '/boardConfig'}, 
            {name: '게시판그룹관리', path: '/boardGroupConfig'}, 
            {name: '팀장님추천', path: '/oneToOneConfig'}, 
        ]
    ],
    ['쇼핑몰관리', 
        [
            {name: '쇼핑몰설정', path: '/shopConfig'}, 
            {name: '분류관리', path: '/itemGroupConfig'}, 
            {name: '상품관리', path: '/itemConfig'}, 
            {name: '상품문의', path: '/itemAdviceConfig'}, 
            {name: '상품재고관리', path: '/itmeQtyConfig'}, 
            {name: '매출현황', path: '/incomConfig'}, 
            {name: '메인화면상품설정', path: '/itemMainConfig'}, 
            // {name: '메인팝업', path: '/mainPopUpConfig'}, 
        ]
    ],
    ['주문현황', 
        [
            {name: '주문내역', path: '/orderListConfig'}, 
            {name: '주문내역출력', path: '/orderListPrintConfig'}, 
            {name: '품목내역출력', path: '/itemListPrintConfig'}, 
        ]
    ],
    ['SMS관리', 
        [
            {name: 'SMS기본설정', path: '/SmsBasic'}, 
        ]
    ],
];


export default dashboardMenus